import react from 'react';
import { Link } from "react-router-dom";

export default class CardButton extends react.Component {
  constructor(props) {
    super(props);
    this.state = {
      label: props.label,
      linkTo: props.linkTo,
      img: props.img,
      alt: props.alt,
      onClick: props.onClick
    };
  }

  componentWillUnmount() {
    this.state.onChange = undefined;
  }

  componentWillReceiveProps(props) {
    this.setState(
      {
        label: props.label,
        linkTo: props.linkTo,
        img: props.img,
        alt: props.alt,
        onClick: props.onClick
      });
  }

  render() {
    return <Link className="card"
      to={this.state.linkTo}
      onClick={(e) => {
        if (this.state.onClick
          && !this.state.onClick()) {
          e.preventDefault()
        }
      }}
    >
        <img src={this.state.img} className={`card-img-top object-fit-cover`} alt={this.state.alt} style={{ width: '100%', height: '6rem' }} />
        <div className="card-body p-2">
          <h5 className="card-title heading hover-highlight text-center mb-0">{this.state.label}</h5>
        </div>
    </Link>
  }
}